export default __webpack_public_path__ + "static/media/sidebar-icon-2.b8ce2df0.svg";